
import { toArray, filter, mergeMap } from 'rxjs/operators';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TasksBackend } from "../../../../backend/tasks.backend";
import { UntypedFormBuilder } from "@angular/forms";
import { TaskReview } from "../../../models/task-review";
import { ListsBackend } from '../../../../backend/lists.backend';
import { Subscription } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'update-request-product-modal',
  templateUrl: './update-request-product-modal.component.html',
  styleUrls: ['./update-request-product-modal.component.scss']
})
export class UpdateRequestProductComponent implements OnDestroy {

  protected _taskProducts: any;
  protected _isDisabled: boolean = true;
  protected _initialProduct: number;
  protected _initialProductSelector;
  protected _selectedProduct;
  protected _submitting = false;
  protected _submitted = false;
  subs: Subscription[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: TaskReview,
    private tasksBackend: TasksBackend,
    private listsBackend: ListsBackend,
    public dialogRef: MatDialogRef<UpdateRequestProductComponent>,
    private _formBuilder: UntypedFormBuilder) {
    this._taskProducts = () => tasksBackend.getRequestProductsByPartner(data.partnerId).pipe(mergeMap(p => <any>p), filter((p: any) => p.id != data.productId), toArray());
    this._initialProduct = data.productId;
    this._initialProductSelector = (p) => p.id == data.productId;
  }

  protected _productSelected(product) {
    this._isDisabled = !product;
    this._selectedProduct = product;
  }

  protected _submit() {
    this._submitting = true;
    const RecountDeadline = this.data.isRequest ? 1 : 0;
    this.subs.push(this.tasksBackend.updateTaskProduct(this.data.id, this._selectedProduct, RecountDeadline).subscribe(res => {
      this._submitting = false;
      this._submitted = true;
      this.dialogRef.close(res);
    }, (err) => {
      this._submitting = false;
      swal.fire({
        title: 'Įvyko klaida',
        timer: 2000,
        showConfirmButton: false,
        icon: 'error'
      });
    }
    ));
  }

  protected _cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
